// @module TavanoTeam.CapSciExtensions.CSSearchSpringExt
define('TavanoTeam.CapSciExtensions.CSSearchSpringExt.CartDetailed.View'
,	[
		'Cart.Detailed.View'
	,	'Profile.Model'

	,	'SC.Configuration'

	,	'underscore'
	,	'jQuery'
	]
,   function (
		CartDetailedView
	,	ProfileModel

	,	Configuration

	,	_
	,	jQuery
	)
{
	'use strict';

	return  {
		loadSearchSpringCart: function loadSearchSpringCart (container)
		{
            _.extend(CartDetailedView.prototype, {
                initialize: _.wrap(CartDetailedView.prototype.initialize, function(fn, options)
                {
                    var origInit = fn.apply(this,_.toArray(arguments).slice(1));

                    options.application.getLayout().once('afterAppendView', this.getItemsCart, this);

                    var a = ProfileModel.getInstance();

                    console.log("a", a);

                    return origInit;
                })
            ,   getItemsCart: function()
                {
                    var lines = _.filter(this.model.get('lines').models || [], function(line) {
                        return line.get('free_gift') !== true;
                    })
                    ,   skuArr = []
                    ,   itemArr = [];

                    _.each(lines, function(items)
                    {
                        var item = items.get('item')
                        ,   itemSKU = item.get('_sku')
                        ,   itemRate = items.get('rate')
                        ,   itemQty = items.get('quantity');

                        itemArr.push({
                            sku: itemSKU
                        ,   qty: itemQty.toString()
                        ,   price: itemRate.toString()
                        });

                        skuArr.push(itemSKU);
                    });

                    this.loadIntelliSuggestCart(skuArr,itemArr);
                }
            ,   loadIntelliSuggestCart: function(sku,items)
                {
                    try {
                        IntelliSuggest.init({siteId:'ejxf37', context:'Basket', seed: sku});

                        _.each(items, function(item)
                        {
                            IntelliSuggest.haveItem(item);
                        });

                        IntelliSuggest.inBasket({});
                    }
                    catch(err)
                    {
                        console.log("err", err);
                    }
                }
            });
		}
	};
});
